import { useCallback } from "react";
import { AnalyticsManager } from "../core/AnalyticsManager";
export const useAnalytics = () => {
    const analytics = AnalyticsManager.getInstance();
    const track = useCallback((eventName, version, payload) => {
        analytics.track(eventName, version, payload);
    }, [analytics]);
    const identify = useCallback((userId, traits) => {
        analytics.identify(userId, traits);
    }, [analytics]);
    const setUserProperties = useCallback((properties) => {
        analytics.setUserProperties(properties);
    }, [analytics]);
    const setGlobalProperties = useCallback((properties) => {
        analytics.setGlobalProperties(properties);
    }, [analytics]);
    const trackScreen = useCallback((screenName, properties) => {
        analytics.screen(screenName, properties);
    }, [analytics]);
    const resetUser = useCallback(() => {
        analytics.resetUser();
    }, [analytics]);
    return {
        track,
        identify,
        setUserProperties,
        setGlobalProperties,
        trackScreen,
        resetUser,
        analyticsInstance: analytics,
    };
};
